import {Box, Chip, Typography} from '@mui/material';
import {useDispatch, useSelector} from 'react-redux';
import {Selector} from '../../state/selector';
import EditIcon from '@mui/icons-material/Edit';
import ReopenWebsiteCheckConfirmation from './ReopenWebsiteCheckConfirmation';
import Command from '../../state/actions/command';
import {useState} from 'react';
import LatestTestDate from '../Admin/AdminPage/LatestTestDate';

const styles = {
    header: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 2,
    },
    statusChip: {
        marginLeft: 2,
    },
};

interface WebsiteCheckHeaderProps {
    title: string;
}

const WebsiteCheckHeader = (props: WebsiteCheckHeaderProps) => {
    const dispatch = useDispatch();
    const websiteCheckLoaded = useSelector(Selector.WebsiteCheck.loaded);
    const websiteCheckId = useSelector(Selector.WebsiteCheck.websiteCheckId);
    const websiteCheckSubmitted = useSelector(Selector.WebsiteCheck.submitted);
    const isAdmin = useSelector(Selector.User.isAdmin);
    const viewingVersion = useSelector(Selector.QuestionList.viewingVersion);
    const companyId = useSelector(Selector.Company.selectedCompanyId);
    const companyStatusMap = useSelector(Selector.Company.companyStatusMap);
    const [reopenConfirmationOpen, setReopenConfirmationOpen] = useState<boolean>(false);

    const reopenWebsiteCheck = () => {
        dispatch(Command.WebsiteCheck.reopenWebsiteCheck({}));
        setReopenConfirmationOpen(false);
    };

    return (
        <Box sx={styles.header}>
            <Typography variant={'h1'}>{props.title}</Typography>
            {(websiteCheckLoaded && websiteCheckId && websiteCheckSubmitted) && (
                <Chip
                    label={'abgeschlossen'}
                    size={'small'}
                    color={'primary'}
                    sx={styles.statusChip}
                    onClick={isAdmin ? () => setReopenConfirmationOpen(true) : undefined}
                    icon={isAdmin ? <EditIcon /> : undefined}
                />
            )}
            {(isAdmin && websiteCheckLoaded && websiteCheckId && companyId) && (
                <>
                    <LatestTestDate
                        data={companyStatusMap[companyId]?.websiteCheck?.[viewingVersion]}
                        useStyle={true}
                    />
                </>
            )}
            <ReopenWebsiteCheckConfirmation
                open={reopenConfirmationOpen}
                onClose={() => setReopenConfirmationOpen(false)}
                onReopen={reopenWebsiteCheck}
            />
        </Box>
    );
};

export default WebsiteCheckHeader;
